import { useParamsStore } from "@/stores/commons/paramsStore";
import hubcore from "@/utils/hubcore.json";

type dataDisplay = {
	display: string;
	x: string;
	y: string;
};

export const useOptions = () => {
	const paramsStore = useParamsStore();
	const { params } = paramsStore as {
		params: {
			display?: string;
			lang?: string;
			client?: string;
			magic?: string;
			options?: {
				longitude?: string;
				latitude?: string;
				radius?: string;
				region?: string;
				customFolder?: string;
			};
		};
	};
	const displayId = params?.display;
	const HUBCORE_URL: string =
		import.meta.env?.VITE_HUBCORE_URL || "https://charming.hub-core.com";

	const HUBCORE_URL_RO: string =
		import.meta.env?.VITE_HUBCORE_URL_RO || "https://api-charming.hub-core.com";

	let HUBCORE_USR: string = params.client ?? import.meta.env?.VITE_HUBCORE_USR;
	let HUBCORE_PWD: string = params.magic ?? import.meta.env?.VITE_HUBCORE_PWD;

	if (!HUBCORE_USR || !HUBCORE_PWD) {
		const data = displayId
			? hubcore.find((o: dataDisplay) => o.display === displayId)
			: null;
		if (!HUBCORE_USR) {
			HUBCORE_USR ||= data?.x ?? "";
		}
		if (!HUBCORE_PWD) {
			HUBCORE_PWD ||= data?.y ?? "";
		}
	}
	// WARNING: Attenzione a non portare questo url di default in produzione!

	const URL =
		import.meta.env?.VITE_BASE_URL || "https://prod-kinboo.hub-core.com";

	/*const URL = import.meta.env?.VITE_BASE_URL || "http://localhost:5173";*/

	const FOLDER_ROOT: string = params.options?.customFolder
		? URL + "/wc/commons/images/" + params.display + "/"
		: URL + "/wc/commons/images/default/";

	return {
		HUBCORE_URL,
		HUBCORE_URL_RO,
		HUBCORE_USR,
		HUBCORE_PWD,
		FOLDER_ROOT,
		URL
	};
};
